import React, { PropsWithChildren } from 'react';

import { Field, useFormikContext } from 'formik';
import classnames from 'classnames';

import { CustomIcon } from '../Icon/CustomIcon';

import styles from './Checkbox.module.scss';

interface CheckboxProps extends PropsWithChildren {
  name: string;
  value: boolean;
  id?: string;
  testId?: string;
  customStyles?: React.CSSProperties;
  customIconStyles?: React.CSSProperties;
  onChange?: () => void;
  disabled?: boolean;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  value,
  name,
  id,
  children,
  testId = '',
  customStyles,
  customIconStyles,
  onChange,
  disabled = false,
}) => {
  const formikProps = useFormikContext();
  return (
    <div
      className={classnames(styles.wrap, { [styles.wrapDisabled]: disabled })}
      style={customStyles}
    >
      <div className={styles.checkbox}>
        <Field
          data-test-id={`checkbox-${testId}`}
          id={id || name}
          type="checkbox"
          name={name}
          checked={value}
          onChange={
            !disabled ? onChange || formikProps.handleChange : undefined
          }
        />
        <CustomIcon
          className={classnames(styles.wrapCheckboxCustom, {
            [styles.wrapCheckboxCustomDisabled]: disabled,
          })}
          style={customIconStyles}
          name={value ? 'checkboxV' : 'checkbox'}
        />
      </div>
      <label className={styles.label} htmlFor={id || name}>
        {children}
      </label>
    </div>
  );
};
